// 用于处理日期格式化的方法
import moment from 'moment'

// moment文档[http://momentjs.cn/docs/]

// 格式列表
const formatType = [
  { type: 1, format: 'YYYY-MM-DD HH:mm:ss' },
  { type: 2, format: 'YYYY-MM-DD' },
  { type: 3, format: 'YYYY/MM/DD HH:mm:ss' },
  { type: 4, format: 'YYYY/MM/DD' },
  { type: 5, format: 'YYYYMM' },
  { type: 6, format: 'YYYY-MM-DD HH:mm' }
]

// 获取类型格式
const getFormatWithType = (type) => {
  let format = formatType[0].format
  formatType.forEach(element => {
    if (element.type === type) {
      format = element.format
    }
  })
  return format
}

/**
 * @description 转成moment类型
 * @param {String} date 需要格式化的值
 * @param {Number} type 类型 参考formatType
 * @returns {Moment} 结果
 */
export const dateToMoment = (date, type) => {
  if (!date) {
    date = new Date()
  }
  return moment(date, getFormatWithType(type))
}
/**
 * @description 转成moment类型
 * @param {String} date 需要格式化的值
 * @param {Number} type 类型 参考formatType
 * @returns {Moment} 结果
 */
export const dateToMomentOrNull = (date, type = 1) => {
  if (!date) {
    return null
  }
  if (moment(date, getFormatWithType(type)).format('YYYY-MM-DD HH:mm:ss') === 'Invalid date') {
    return null
  }
  return moment(date, getFormatWithType(type))
}

/**
 * @description 转成String类型
 * @param {Date} date 需要格式化的值
 * @param {Number} type 类型 参考formatType
 * @returns {String} 结果
 */
export const dateToString = (date, type) => {
  if (!date) {
    return ''
  }
  return moment(date).format(getFormatWithType(type))
}

/**
 * @description 获取月份的月初月末
 * @param {Date} date yyyy-MM
 * @returns {Array} 结果
 */
export const getFirstDayLastDay = (date) => {
  if (!date) {
    return null
  }
  if (moment(date).format('YYYY-MM-DD HH:mm:ss') === 'Invalid date') {
    return null
  }
  return [moment(moment(date).startOf('month').format('YYYY-MM-DD HH:mm:ss')).add(8, 'hours'),
    moment(moment(date).endOf('month').format('YYYY-MM-DD HH:mm:ss')).add(8, 'hours')]
}
/**
 * @description 获取日初日末
 * @param {Date} date yyyy-MM-dd
 * @returns {Array} 结果
 */
export const getDayStart = (date) => {
  if (!date) {
    return null
  }
  if (moment(date).format('YYYY-MM-DD HH:mm:ss') === 'Invalid date') {
    return null
  }
  return moment(date).startOf('day').add(8, 'hours')
}
export const getDayEnd = (date) => {
  if (!date) {
    return null
  }
  if (moment(date).format('YYYY-MM-DD HH:mm:ss') === 'Invalid date') {
    return null
  }
  return moment(date).endOf('day').add(8, 'hours')
}
